import { takeEvery, select, put } from 'redux-saga/effects';

import { actions as activityLogActions } from '../patientPortal/activity-log-req';
import { consts as activityLogConsts } from '../patientPortal/activity-log-req';
import {
  selectActivityLogEntityOffset,
  selectActivityLogEntityIsLastPage,
} from '../patientPortal/selectors';

function* loadMoreWorker(action) {
  const { payload } = action;
  const { userId, withPagination } = payload;

  const limit = 15;
  const currentOffset = yield select(selectActivityLogEntityOffset);
  const newOffset = withPagination ? currentOffset + limit : currentOffset;
  const isLastPage = yield select(selectActivityLogEntityIsLastPage);

  if (!isLastPage) {
    yield put(
      activityLogActions.send({
        limit,
        userId,
        offset: newOffset,
      }),
    );
  }
}

export default function* activityLogLoadMoreSaga() {
  yield takeEvery([activityLogConsts.LOAD_MORE], loadMoreWorker);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/activity-log-load-more.js